import { createApp, h } from "vue";
import { App as AntdApp, ConfigProvider, Spin } from "antdv-next";
import zhCN from "antdv-next/locale/zh_CN";
import "antdv-next/dist/reset.css";
import App from "./App.vue";
import logoSpinIndicator from "@/assets/logo-gradient-loader.svg";
import router from "./router/index.js";
import pinia from "./store/index.js";
import i18n from "./locales/index.js";
import vueEcharts from "./plugins/vueEcharts.js";

import "@/utils/permission.js"; // permission control
import "@/assets/css/global.less"; // global style
import "@/assets/css/tailwind.css";
import antdTheme from "@/config/theme.js";
import { setupDayjs } from "@/utils/date.js";

setupDayjs();

Spin.setDefaultIndicator(
  h("img", {
    src: logoSpinIndicator,
    alt: "",
    "aria-hidden": "true",
    class: "ndb-spin-logo-loader"
  })
);

ConfigProvider.config({
  holderRender: (children) =>
    h(
      ConfigProvider,
      { locale: zhCN, theme: antdTheme },
      {
        default: () => h(AntdApp, null, { default: () => children })
      }
    )
});

// mount axios to `Vue.$http` and `this.$http`
const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(i18n);
app.use(vueEcharts);

app.mount("#app");
